import React from "react";
import { useIntersectionObserver } from "@react-hookz/web";
import { useIntl } from "gatsby-plugin-intl";
import DoubleDiamondHover from "@assets/images/how-to-play/double-diamond-hover.png";
import DoubleDiamond from "@assets/images/how-to-play/double-diamond.png";
import DiamondLine from "@assets/images/how-to-play/vertical-diamond-line.svg";
import { mq, scrollTo } from "../util";

const SideNav = ({ items }) => (
  <div
    css={mq({
      display: ["none", null, "grid"],
      gap: 31,
      gridTemplateRows: "repeat(3, 20px)",
      position: "fixed",
      left: 48,
      top: "calc((100vh - 125px) / 2)",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="7" height="102"><image width="7" height="76" xlink:href="${DiamondLine}" /></svg>')`,
      backgroundPosition: "7px 23px",
      backgroundRepeat: "repeat-y",
    })}>
    {items.map(({ target, text }, index) => (
      <SideTab key={`side-tab-${index}`} target={target}>
        {text}
      </SideTab>
    ))}
  </div>
);

const SideTab = ({ children, target }) => {
  const { locale } = useIntl();
  const entry = useIntersectionObserver(target);
  const isVisible = !!entry?.isIntersecting;

  return (
    <button
      data-side-tab=""
      type="button"
      onClick={() => scrollTo(target)}
      css={{
        display: "flex",
        alignItems: "center",
        color: isVisible ? "#fff" : "rgba(255,255,255,.3)",
        "[data-side-tab-text]": {
          color: isVisible ? "#374968" : "#fff",
        },
        "&:hover": {
          color: "#fff",
          "[data-side-tab-text]": {
            color: "#374968",
          },
        },
      }}>
      <div
        css={{
          width: 20,
          height: 20,
          background: `url(${
            isVisible ? DoubleDiamondHover : DoubleDiamond
          }) 50% 50% / contain no-repeat`,
          marginRight: "-3px",
          "[data-side-tab]:hover &": {
            backgroundImage: `url(${DoubleDiamondHover})`,
          },
        }}
      />
      <div
        css={{
          borderTop: "10px solid currentColor",
          borderBottom: "10px solid currentColor",
          borderRight: "8px solid currentColor",
          borderLeft: "8px solid transparent",
        }}
      />
      <div
        css={{
          padding: "0 10px",
          lineHeight: "20px",
          background: "currentColor",
          letterSpacing: locale !== "en" && "4px",
          fontSize: 14,
        }}>
        <div data-side-tab-text="">{children}</div>
      </div>
      <div
        css={{
          height: 0,
          width: 0,
          borderTop: "10px solid transparent",
          borderBottom: "10px solid transparent",
          borderLeft: "8px solid currentColor",
        }}
      />
    </button>
  );
};

export default SideNav;
